export default __webpack_public_path__ + "static/media/homepage_logo.1977c355.svg";